import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { getUrlToken } from "../utils/urlTokenAuth";

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const hasResetToken =
    (location.pathname.includes("reset-password") ||
      location.pathname.includes("password-change")) &&
    getUrlToken(location.search);

  if (isAuthenticated && !hasResetToken) {
    return <Navigate to="/page-group" replace />;
  }

  return children;
};

export default PublicRoute;
